import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '@store/constants';

import * as cartQuantityActions from './actions/cartQuantityActions';
import { prepareWithCart, resetCart } from './actions/prepareActions';

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        prepareWithCart,
        resetCart,
        ...cartQuantityActions,
    },
});

export const cartActions = cartSlice.actions;

export default cartSlice.reducer;
